module.exports = __webpack_public_path__ + "static/media/country_tq.413ac342.webp";